import {tns} from "../../../node_modules/tiny-slider/src/tiny-slider"
import {DIV_SLIDERS} from "../constants";

export const initSliders = () => {
	const elements = Array.from(document.querySelectorAll(`div.slider-wrapper`));

	if (elements)
	{
		elements.forEach((element, i) => {
			element.setAttribute(`data-i`, i);
			const slider = tns({
				container: element.querySelector(`ul.slider`),
				items: 1,
				slideBy: 1,
				speed: 700,
				preventScrollOnTouch: true,
				controlsContainer: element.querySelector(`ul.bookmarks`),
				nav: false,
				rewind: true,
				onInit: () => element.classList.add(`loaded`),
			});
			
			window.innerWidth >= 976 ? slider.rebuild() : slider.destroy();
			
			DIV_SLIDERS.push(slider);
		});
		
		window.addEventListener(`resize`, () => {
			window.innerWidth >= 976 ? DIV_SLIDERS.forEach((el) => el = el.rebuild()) : DIV_SLIDERS.forEach((el) => el.destroy ? el.destroy() : false); 
		});
	}
};
